import "./Correio.css"
import pdf from "../../images/pdfIcon.svg"
import arrowMoreRight from "../../images/arrowMoreRight.svg"

export default function DocumentItem({ document, onSelect }) {
    const formattedDate = new Intl.DateTimeFormat("pt-PT").format(new Date(document.date))
    return (
        <div className="doc-card" onClick={() => onSelect(document)}>
            <div className="doc-card-left">
                <img
                    src={pdf}
                    alt="PDF"
                    className="doc-pdf-icon"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://cdn-icons-png.flaticon.com/512/337/337946.png";
                    }}
                />
                <div className="doc-info">
                    <h4 className={`doc-title ${!document.isRead ? 'unread' : 'read'}`}>
                        {document.title}
                    </h4>
                    <p className="doc-date">
                        {formattedDate}
                    </p>
                </div>
            </div>
            <div className="doc-arrow">
                <img src={arrowMoreRight} />
            </div>
        </div>
    );
};